/* eslint-disable no-console */

import { register } from 'register-service-worker';
// import store from './store/';

window.newWorker;

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready(reg) {
            console.log('Service worker ready', reg);
            window.newWorker = reg.installing;
        },
        registered() {
            console.log('Service worker has been registered.');
        },
        cached() {
            console.log('Content has been cached for offline use.');
        },
        updatefound(reg) {
            window.newWorker = reg.installing;
            // store.commit('newWorker', newWorker);
            window.newWorker.onstatechange = () => {
                console.log('window.newWorker.state', window.newWorker.state)
                switch (window.newWorker.state) {
                    case 'installed':
                        let updateAvailable = false;
                        if (navigator.serviceWorker.controller) {
                            updateAvailable = true;
                        }
                        console.log('Update Available', updateAvailable);
                        // store.commit('updateAvailable', updateAvailable);
                        break;
                }
            }
        },
        updated() {
            console.log('New content is available; please refresh.');
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.');
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        },
    });
}
